import React, { Component } from "react";
import _ from "lodash";
import { TermsOfUse, PrivacyPolicy } from "../components/PDPA";

import { withRedux } from "../hoc";

const mapStateToProps = ({ language, t }) => {
  return {
    language,
    t,
  };
};

@withRedux(mapStateToProps)
export default class Pdpa extends Component {
  render() {
    const {
      t,
      language,
      match: { params },
    } = this.props;
    const currentLanguage = _.get(language, "currentActive");

    return (
      <div style={{ position: "relative" }}>
        {params.type === "terms-of-use" ? (
          <TermsOfUse t={t} currentLanguage={currentLanguage} />
        ) : (
          <PrivacyPolicy t={t} currentLanguage={currentLanguage} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Pdpa.js